const TEST_IDS = {
  tokenTextField: "borrow-modal-token-text-field",
};

export default TEST_IDS;
